// eslint-disable-next-line import/prefer-default-export
export const setProperties = properties => async dispatch =>
  dispatch({type: 'SET_PROPERTIES', properties});
